export function formattedUrl(url: string | null): string {
    const trimmedUrl = url?.trim();
    if (!trimmedUrl) {
        return "";
    }
    let domain = trimmedUrl.replace(/(^\w+:|^)\/\//, "");
    domain = domain.replace(/^www\./, "");
    domain = domain.split("/")[0];

    return domain;
}

export function ensureHttps(url: string): string {
    const website = formattedUrl(url);

    return `https://${website}`;
}

export const URL_REGEX =
    /^(?:(?:https?):\/\/)?(?:www\.)?[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?)+(?::\d{1,5})?(?:\/[^\s]*)?$/i;
